import React from 'react';
import { useNavigate } from 'react-router-dom';
import './HomePage.css';

function HomePage() {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/login');
  };

  return (
    <div className="home-page">
      <div className="home-container">
        <header className="home-header">
          <h1>📮✨ InboxPro by Stealzers</h1>
          <p className="tagline">Transform your Gmail chaos into organized bliss</p>
        </header>

        <section className="hero-section">
          <div className="hero-content">
            <h2>Never Miss What Matters</h2>
            <p>Smart AI-powered email organization that automatically sorts, categorizes, and saves important information from your inbox.</p>
            <button className="cta-button" onClick={handleGetStarted}>
              Get Started Free
            </button>
          </div>
          <div className="hero-image">
            <div className="email-preview">
              <div className="email-item important">⭐ Important</div>
              <div className="email-item coupon">🎟️ Coupons</div>
              <div className="email-item code">🔑 Account Codes</div>
            </div>
          </div>
        </section>

        <section className="features-section">
          <h2>Powerful Features</h2>
          <div className="features-grid">
            <div className="feature-card">
              <span className="feature-icon">⭐</span>
              <h3>Smart Importance Ranking</h3>
              <p>AI analyzes your emails and ranks them by relevance to you. Never miss critical messages again.</p>
            </div>
            <div className="feature-card">
              <span className="feature-icon">🎟️</span>
              <h3>Auto-Save Coupons</h3>
              <p>Automatically detects and saves coupons and promo codes. Never lose a discount again.</p>
            </div>
            <div className="feature-card">
              <span className="feature-icon">🔑</span>
              <h3>Account Code Tracking</h3>
              <p>Captures verification codes, tracking numbers, and important account information.</p>
            </div>
            <div className="feature-card">
              <span className="feature-icon">🤖</span>
              <h3>AI Assistant</h3>
              <p>Ask questions about your emails and get instant, intelligent answers powered by Claude AI.</p>
            </div>
            <div className="feature-card">
              <span className="feature-icon">🔒</span>
              <h3>Auto-Clean Spam</h3>
              <p>Automatically identifies and filters out spam and unwanted promotional emails.</p>
            </div>
            <div className="feature-card">
              <span className="feature-icon">⚡</span>
              <h3>Real-time Scanning</h3>
              <p>Continuous monitoring keeps your inbox organized 24/7. Set it and forget it.</p>
            </div>
          </div>
        </section>

        <section className="how-it-works">
          <h2>How It Works</h2>
          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <h3>Connect Your Gmail</h3>
              <p>Securely sign in with your Google account. We only request read access to your emails.</p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <h3>AI Organizes Everything</h3>
              <p>Our intelligent system scans and categorizes your emails automatically.</p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <h3>Enjoy Your Clean Inbox</h3>
              <p>Access organized emails, saved coupons, and important codes anytime.</p>
            </div>
          </div>
        </section>

        <section className="cta-section">
          <h2>Ready to Take Control of Your Inbox?</h2>
          <p>Join thousands of users who've already transformed their email experience.</p>
          <button className="cta-button-large" onClick={handleGetStarted}>
            Sign In with Google
          </button>
        </section>

        <footer className="home-footer">
          <p>&copy; 2026 InboxPro by Stealzers. All rights reserved.</p>
          <div className="footer-links">
            <a href="/privacy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
            <span>•</span>
            <a href="/terms.html" target="_blank" rel="noopener noreferrer">Terms of Service</a>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default HomePage;
